<template>
    <div>
        <img src="http://via.placeholder.com/295x209" />
        <div class="welcome-video text-center py-4">
            <h5 class="sau-para-m">Customer Experience Team</h5>
        </div>
    </div>
</template>

<script>
export default {

}
</script>

<style lang="scss">

</style>
